export function selector(args: TemplateStringsArray): string {
  return `[class*=${args[0].substring(1)}]`;
}
